export const isValidArray = (arr: any) => {
  return arr && Array.isArray(arr) && arr.length > 0;
};

export const isValidObject = (obj: any) => {
  return obj && Object.keys(obj).length > 0;
};

// Return 'true' if the passed value is null or empty
export function IsNullOrEmpty(pVal: any): boolean {
  return (
    typeof pVal === 'undefined' ||
    pVal === null ||
    (typeof pVal === 'string' && String(pVal.trim()).length === 0) ||
    (typeof pVal === 'object' && Object.keys(pVal).length === 0)
  );
}

// Return 'true' if the passed value is not null or empty
export function IsNotNullOrEmpty(pVal: any): boolean {
  return !IsNullOrEmpty(pVal);
}

export function isValidUrlFormat(input: string): boolean {
  try {
    const u = new URL(input);
    // Optional: restrict to http/https schemes
    return u.protocol === 'http:' || u.protocol === 'https:';
  } catch {
    return false;
  }
}

export function isEqualObject(obj1: any, obj2: any): boolean {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}
